<fc-general-modal [baseId]="baseId" [form]="form" [fcModalItemContext]="fcModalItemContext" (saveForm)="save()" (cancelForm)="onCancel()">
  <div [formGroup]="form">
    <!-- External Id Control -->
    <div class="form-group">
      <label for="{{ baseId }}-id" translate>ID</label>
      <input
        id="{{ baseId }}-id"
        class="form-control"
        [ngClass]="{
          error: showErrors(externalIdControl, isSubmitted),
          'required': isRequired(externalIdControl)
        }"
        type="text"
        [maxlength]="fcListValidation.validations.ExternalID.MaxLength"
        formControlName="externalId"
      />
      <div *ngIf="showErrors(externalIdControl, isSubmitted)" id="{{ baseId }}-warning-text-id" class="incorrect-input" translate>
        {{ externalIdControl.errors | fcListValidation : 'ID' }}
      </div>
    </div>
    <!-- External Id Control -->

    <!-- Name Control -->
    <div class="form-group">
      <label for="{{ baseId }}-name" translate>Name</label>
      <input
        id="{{ baseId }}-name"
        class="form-control"
        [ngClass]="{
          error: showErrors(nameControl, isSubmitted),
          'required': isRequired(nameControl)
        }"
        type="text"
        [maxlength]="fcListValidation.validations.Name.MaxLength"
        formControlName="name"
      />
      <div *ngIf="showErrors(nameControl, isSubmitted)" id="{{ baseId }}-warning-text-name" class="incorrect-input" translate>
        {{ nameControl.errors | fcListValidation : 'Name' }}
      </div>
    </div>
    <!-- Name Control -->

    <!-- Notes Control -->
    <div class="form-group full-control">
      <label for="{{ baseId }}-notes" translate>Notes</label>
      <textarea
        class="form-control"
        [ngClass]="{
          error: showErrors(notesControl, isSubmitted),
          'required': isRequired(notesControl)
        }"
        id="{{ baseId }}-notes"
        formControlName="notes"
        [maxlength]="fcListValidation.validations.Notes.MaxLength"
        rows="3"
      >
      </textarea>
      <div *ngIf="showErrors(notesControl, isSubmitted)" id="{{ baseId }}-warning-text-notes" class="incorrect-input" translate>
        {{ notesControl.errors | fcListValidation : 'Notes' }}
      </div>
    </div>
    <!-- Notes Control -->

    <!-- Inactive and User Defined checkboxes -->
    <div class="checkbox-group">
      <mat-checkbox id="{{ baseId }}-inactive-checkbox" formControlName="inactive" translate>Inactive </mat-checkbox>
      <mat-checkbox id="{{ baseId }}-user-defined-checkbox" formControlName="userDefined" translate>User Defined </mat-checkbox>
    </div>
    <!-- Inactive and User Defined checkboxes -->
  </div>
</fc-general-modal>
